/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/first_aid'
export default icon
